export default "__VITE_ASSET__a93bb7ab__"